import { StarIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
interface StarsProps {
  rating: number;
  className?: string;
  size?: number;
}
export function Stars({
  rating,
  className = '',
  size = 16
}: StarsProps) {
  const {
    t
  } = useLanguage();
  return <span className={`inline-flex items-center gap-0.5 ${className}`} role="img" aria-label={`${rating} ${t(copy.testimonials.starsLabel)}`} data-id="element-307" data-mp="3pphtc87hftcx">
      {[1, 2, 3, 4, 5].map(value => <StarIcon key={value} width={size} height={size} aria-hidden="true" className={value <= Math.round(rating) ? 'fill-gold-400 text-gold-400' : 'text-navy-300'} data-id="element-308" data-mp="3gztsrstyyfj" />)}
    </span>;
}